import { FC, useCallback, useEffect, useMemo } from 'react';
import intl from 'react-intl-universal';
import { Dropdown, FormItem } from '@getsynapse/design-system';
import { Option } from 'utils/customTypes';
import { useProjectProcesses } from 'Pages/ProjectsListPage/hooks/useProjectProcesses/useProjectProcesses';

interface ProjectProcessFilterProps {
  onSelect: (selected: string[]) => void;
  selected?: string[];
}

const ProjectProcessFilter: FC<ProjectProcessFilterProps> = ({
  onSelect,
  selected,
}) => {
  const { fetchProcesses, processes } = useProjectProcesses({
    appliedFilters: [],
  });

  useEffect(() => {
    fetchProcesses();
  }, [fetchProcesses]);

  const options = useMemo(() => {
    return processes.map((process) => ({
      label: process.name,
      value: process.id,
    }));
  }, [processes]);

  const selectedProcesses = options.filter((process) =>
    selected?.includes(process.value)
  );

  const handleChange = useCallback(
    (options: Option[]) => {
      const selectedIds = options.map((option) => option.value);
      onSelect(selectedIds);
    },
    [onSelect]
  );

  return (
    <FormItem label={intl.get('PROJECT_DETAIL.PROCESS')}>
      <Dropdown
        options={options}
        onChange={handleChange}
        values={selectedProcesses}
        multiple
        placeholder={intl.get('FILTER_GENERAL.PLACEHOLDER')}
        triggerProps={{
          'aria-label': 'project-process-filter',
        }}
      />
    </FormItem>
  );
};

export default ProjectProcessFilter;
